import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { PageLoading, EmptyState } from "@dosa/ui";
import { generateMedicationManagementReport } from "../../lib/api-client";
import { MedicationReportView } from "../../components/report/MedicationReportView";

export function PatientReportViewPage() {
  const { assessmentId } = useParams<{ assessmentId: string }>();

  const { data: report, isLoading } = useQuery({
    queryKey: ["report", assessmentId],
    queryFn: () => generateMedicationManagementReport(assessmentId!),
    enabled: !!assessmentId,
  });

  if (isLoading) return <PageLoading />;
  if (!report) return <EmptyState title="Report not found" />;

  return <MedicationReportView report={report} audience="PATIENT_FRIENDLY" />;
}
